import { Link, NavLink, useLocation } from "react-router-dom";
import { History, Home, Pen } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "../lib/utils";

export interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();

  return (
    <div className="min-h-full flex flex-col">
      <header className="sticky top-0 z-30 border-b border-[color:var(--border)] bg-[color:var(--surface)]/80 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4">
          <Link to="/" className="flex items-center gap-2 font-semibold tracking-tight">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-[color:var(--primary)] text-[color:var(--bg)]">
              <Pen className="h-4 w-4" />
            </span>
            <span>练字指导</span>
          </Link>
          <nav className="flex items-center gap-1 text-sm">
            <NavItem to="/" icon={<Home className="h-4 w-4" />} label="首页" active={location.pathname === "/"} />
            <NavItem
              to="/history"
              icon={<History className="h-4 w-4" />}
              label="历史"
              active={location.pathname.startsWith("/history")}
            />
          </nav>
        </div>
      </header>
      <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-6">{children}</main>
      <footer className="border-t border-[color:var(--border)] py-6 text-center text-xs text-[color:var(--text-muted)]">
        © {new Date().getFullYear()} PracticeWord · 练字指导
      </footer>
    </div>
  );
}

function NavItem({
  to,
  icon,
  label,
  active,
}: {
  to: string;
  icon: ReactNode;
  label: string;
  active: boolean;
}) {
  return (
    <NavLink
      to={to}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 transition-colors",
        active
          ? "bg-[color:var(--surface-2)] text-[color:var(--text)]"
          : "text-[color:var(--text-muted)] hover:bg-[color:var(--surface-2)] hover:text-[color:var(--text)]",
      )}
    >
      {icon}
      <span>{label}</span>
    </NavLink>
  );
}
